module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/passthrough.js
// module id = 62
// module chunks = 0